<div class="wrapper mt-10 w-full mb-16">
  <div class="w-full">
    <h2 class="text-2xl font-bold text-black-900">{{dataSource?.Title}}</h2>
  </div>
    <section class="grid grid-cols-2 grid-rows-2 md:grid-cols-4 gap-4 h-auto mt-7">
      <div class="city_card col-span-1 row-span-2 rounded-xl relative">
        <a [href]="dataSource.Section.Data.Details[0]?.Url" target="_blank">
          <img [src]="dataSource.Section.Data.Details[0]?.PictureUrl" alt="" id="pic-multisquare" class="h-full rounded-xl" />
          <div class="city_desc absolute">
            <div class="lg:text-lg font-bold text-white text-sm">{{dataSource.Section.Data.Details[0]?.Name}}</div>
            <div
              class="w-[95px] lg:text-md font-bold text-white text-xs rounded-md text-center flex items-center justify-between">
              <span><i class="ico ico-City"></i></span>
              <span>{{dataSource.Section.Data.Details[0]?.Count}}</span>
              <span>واحد اقامتی</span>
            </div>
          </div>
        </a>
      </div>
      <div class="city_card col-span-1 row-span-2 rounded-xl relative">
        <a [href]="dataSource.Section.Data.Details[1]?.Url" target="_blank">
          <img [src]="dataSource.Section.Data.Details[1]?.PictureUrl" alt="" id="pic-multisquare" class="h-full rounded-xl" />
          <div class="city_desc absolute">
            <div class="lg:text-lg font-bold text-white text-sm">{{dataSource.Section.Data.Details[1]?.Name}}</div>
            <div
              class="w-[95px] lg:text-md font-bold text-white text-xs rounded-md text-center flex items-center justify-between">
              <span><i class="ico ico-City"></i></span>
              <span>{{dataSource.Section.Data.Details[1]?.Count}}</span>
              <span>واحد اقامتی</span>
            </div>
          </div>
        </a>
      </div>
      <div class="city_card col-span-1 row-span-1 rounded-xl relative"
       *ngFor="let city of dataSource.Section.Data.Details.slice(2);let index = index">
          <a [href]="city?.Url" target="_blank">
            <img [src]="city?.PictureUrl" alt="" id="pic-multisquare" class="h-[184px] w-[288px] object-cover rounded-xl" />
            <div class="city_desc absolute">
              <div class="lg:text-lg font-bold text-white text-sm">{{city?.Name}}</div>
              <div
                class="w-[95px] lg:text-md font-bold text-white text-xs rounded-md text-center flex items-center justify-between">
                <span><i class="ico ico-City"></i></span>
                <span>{{city?.Count}}</span>
                <span>واحد اقامتی</span>
              </div>
            </div>
          </a>
      </div>
    </section>
</div>